import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
function CateringPackages() {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            setError(null);

            try {
                showLoader();
                const authToken = localStorage.getItem("authToken");
                if (!authToken) throw new Error("No auth token found. Please login.");

                const response = await fetch(
                    "https://backend.maamaas.com/catering/api/admin/all",
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                            Accept: "*/*",
                        },
                    }
                );

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const data = await response.json();
                setOrders(data);
                localStorage.setItem("ordersData", JSON.stringify(data));
            } catch (err) {
                console.error("Error fetching orders:", err);
                setError("Failed to load orders.");

                // Load from localStorage if API fails
                const storedOrders = localStorage.getItem("ordersData");
                if (storedOrders) {
                    setOrders(JSON.parse(storedOrders));
                    // console.log("✅ Loaded orders from localStorage");
                }
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchOrders();
    }, []);


    // ✅ Filter orders by selected date
    useEffect(() => {
        if (!selectedDate) {
            setFilteredOrders(orders);
        } else {
            const filtered = orders.filter((order) => {
                if (!order.eventDate) return false;
                return order.eventDate.startsWith(selectedDate); // Matches yyyy-mm-dd
            });
            setFilteredOrders(filtered);
        }
    }, [selectedDate, orders]);

    // ✅ Export Excel function
    const exportToExcel = () => {
        if (filteredOrders.length === 0) {
            alert("No data to export!");
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(filteredOrders);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Catering Orders");
        XLSX.writeFile(workbook, "CateringOrders.xlsx");
    };

    if (loading) return <p>Loading orders...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif" }}>
            {/* 🔹 Filter and Export Section */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                    marginTop: "10px",
                }}
            >
                <div>

                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={filterSelectStyle}
                    />
                </div>

                <button
                    onClick={exportToExcel}
                    style={{
                        backgroundColor: "rgb(230 109 51)",
                        color: "#fff",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "bold",
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "rgb(230 109 51)")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "rgb(230 109 51)")}
                >
                    Export
                </button>
            </div>

            {/* 🔹 Table Section */}
            <div
                style={{
                    maxHeight: "420px",
                    overflowY: "auto",
                    overflowX: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    scrollbarWidth: "thin",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "5px",
                        fontSize: "15px",
                    }}
                >
                    <thead>
                        <tr
                            style={{
                                backgroundColor: "rgb(230 109 51)",
                                color: "white",
                                height: "38px",
                            }}
                        >
                            <th style={thStyle}>User ID</th>
                            <th style={thStyle}>Order ID</th>
                            <th style={thStyle}>Name</th>
                            <th style={thStyle}>Email Id</th>
                            <th style={thStyle}>Mobile Number</th>
                            <th style={thStyle}>Location</th>
                            <th style={thStyle}>Event Date</th>
                            <th style={thStyle}>Event Type</th>
                            <th style={thStyle}>Veg Plates</th>
                            <th style={thStyle}>Non-Veg Plates</th>
                            <th style={thStyle}>Mixed Plates</th>
                            <th style={thStyle}>Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={12}
                                    style={{ textAlign: "center", padding: "10px" }}
                                >
                                    No orders found.
                                </td>
                            </tr>
                        ) : (
                            filteredOrders.map((item, index) => (
                                <tr key={index}>
                                    <td style={tdStyle}>{item.userId || "N/A"}</td>
                                    <td style={tdStyle}>Order{item.id || "N/A"}</td>
                                    <td style={tdStyle}>{item.fullName || "N/A"}</td>
                                    <td style={tdStyle}>{item.email || "N/A"}</td>
                                    <td style={tdStyle}>{item.phoneNumber || "N/A"}</td>
                                    <td style={tdStyle}>{item.city || "N/A"}</td>
                                    <td style={tdStyle}>
                                        {item.eventDate
                                            ? new Date(item.eventDate).toLocaleDateString("en-GB") // "en-GB" → dd/mm/yyyy format
                                            : "N/A"}
                                    </td>

                                    <td style={tdStyle}>{item.eventType || "N/A"}</td>
                                    <td style={tdStyle}>{item.vegPlates || "N/A"}</td>
                                    <td style={tdStyle}>{item.nonVegPlates || "N/A"}</td>
                                    <td style={tdStyle}>{item.mixedPlates || "N/A"}</td>
                                    <td style={tdStyle}>{item.budget || "N/A"}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// Styles
const thStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
};

const tdStyle = {
    border: "1px solid #ccc",
    padding: "10px",
};
const filterSelectStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};
export default CateringPackages;
